import { css } from 'styled-components';
import {COLORS, focusStyles} from '../styles';

export const CommonInteractionStyling = css`
  &:focus, &.focus-state, &.focus-visible {
    ${focusStyles}
  }

  &:hover:not(.action-within), &.hover-state {
    background-color: ${COLORS.primary_20};
    color: ${COLORS.primary_600};
  }
  &:active:not(.action-within), &.active-state {
    background-color: ${COLORS.primary_100};
    color: ${COLORS.primary_800};
  }
  &:disabled, &.disabled-state {
    background-color: ${COLORS.white};
    span {
      color: ${COLORS.neutral_300};
    }
    &::after {
      background-color: ${COLORS.white};
    }
  }
`;
